import {
    cleanCommonParams,
    mapRequestItemsParams,
    mapImageParams,
} from './common';

const mapCollateralRequestParams = (
    isCreate,
    {
        collateral_request_templates,
        total_quantity,
        mdf_total,
        items_requested_count,
        download_url,
        collateral_templates,
        attachment,
        state,
        image,
        premier_access_group_id,
        premier_access_group,
        user_id,
        user,
        agency_address,
        request_notifications,
        generating,
        ...params
    },
) => {
    return new Promise((resolve) => {
        resolve({
            collateral_request: {
                ...cleanCommonParams(params),
                ...mapImageParams(isCreate, image),
                ...mapRequestItemsParams(isCreate, collateral_request_templates),
            },
        });
    });
};

export { mapCollateralRequestParams };
